document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.querySelector('[data-vilux-sticky-buy]');
  if (!stickyBar) return;

  const stickyButton = stickyBar.querySelector('[data-vilux-sticky-button]');
  const stickyPrice = stickyBar.querySelector('[data-vilux-sticky-price]');
  const productInfo = document.querySelector('.product__info-container');

  if (!productInfo) return;

  function getMainProductForm() {
    return productInfo.querySelector('form[action*="/cart/add"]');
  }

  function getAddButton() {
    return productInfo.querySelector('.product-form__submit');
  }

  function getDynamicCheckoutButton() {
    return productInfo.querySelector('.shopify-payment-button__button');
  }

  function getCurrentPrice() {
    const priceContainer = productInfo.querySelector('[id^="price-"], .price');

    if (!priceContainer) return null;

    const salePrice = priceContainer.querySelector(
      '.price__sale .price-item--sale'
    );

    const regularPrice = priceContainer.querySelector(
      '.price__regular .price-item--regular'
    );

    if (
      salePrice &&
      window.getComputedStyle(salePrice).display !== 'none'
    ) {
      return salePrice.textContent.trim();
    }

    if (regularPrice) {
      return regularPrice.textContent.trim();
    }

    const fallback = priceContainer.querySelector('.price-item');

    return fallback ? fallback.textContent.trim() : null;
  }

  function syncStickyBar() {
    const form = getMainProductForm();
    const addButton = getAddButton();

    const variantInput = form
      ? form.querySelector('input[name="id"]')
      : null;

    const currentPrice = getCurrentPrice();

    if (currentPrice) {
      stickyPrice.textContent = currentPrice;
    }

    const unavailable =
      !variantInput ||
      !variantInput.value ||
      variantInput.disabled ||
      (addButton && addButton.disabled);

    stickyButton.disabled = unavailable;

    stickyButton.textContent = unavailable
      ? 'Agotado'
      : 'Realizar pedido';
  }

  stickyButton.addEventListener('click', async () => {
  if (
    stickyButton.disabled ||
    stickyButton.dataset.loading === 'true'
  ) {
    return;
  }

  const form = getMainProductForm();

  if (!form) {
    console.error('Vilux: no se encontró el formulario del producto.');
    return;
  }

  const variantInput = form.querySelector('input[name="id"]');

  if (!variantInput || !variantInput.value) {
    console.error('Vilux: no se encontró la variante seleccionada.');
    return;
  }

  stickyButton.dataset.loading = 'true';
  stickyButton.disabled = true;
  stickyButton.textContent = 'Procesando...';

  try {
    const quantityInput = form.querySelector('input[name="quantity"]');

    const quantity = quantityInput
      ? parseInt(quantityInput.value, 10) || 1
      : 1;

    const root =
      window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root
        : '/';

    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantInput.value),
            quantity: quantity
          }
        ]
      })
    });

    if (!response.ok) {
      throw new Error('No se pudo agregar el producto al pedido.');
    }

    window.location.assign(root + 'checkout');

  } catch (error) {
    console.error('Vilux - Realizar pedido:', error);

    stickyButton.dataset.loading = 'false';
    stickyButton.disabled = false;
    stickyButton.textContent = 'Realizar pedido';

    alert(
      'No pudimos iniciar el pedido. Por favor intenta nuevamente.'
    );
  }
});

  productInfo.addEventListener('change', () => {
    setTimeout(syncStickyBar, 150);
  });

  const observer = new MutationObserver(syncStickyBar);

  observer.observe(productInfo, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled', 'class']
  });

  syncStickyBar();
});